import { Link } from "react-router-dom";
import { Check, RotateCcw, Ban, ShieldCheck, Infinity } from "lucide-react";
import { BuyButton } from "@/components/BuyButton";
import { TrustBadges } from "@/components/TrustBadges";
import { STORE } from "@/constants/testIds";
import { ACCESS_TIMING_TEXT, PRODUCT, TRUST_POINTS } from "@/data/content";

const CTA_REASSURANCE = [
  { icon: RotateCcw, text: "7-day satisfaction refund" },
  { icon: Ban, text: "No subscription, ever" },
  { icon: ShieldCheck, text: "Secure checkout" },
  { icon: Infinity, text: "Lifetime access — yours until you pass" },
];

export const PurchaseCard = () => {
  const deliveryText = ACCESS_TIMING_TEXT;

  return (
    <div className="lg:sticky lg:top-24">
    <div className="rounded-2xl border border-[color:rgba(10,27,51,0.14)] bg-white p-6 shadow-[0_14px_40px_rgba(7,20,39,0.10)]">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#B7791F]">
        One price. Everything included.
      </p>
      <div className="flex items-baseline gap-2">
        <span
          data-testid={STORE.productPrice}
          className="font-[var(--font-heading)] text-4xl font-bold text-[var(--ibp-ink)]"
        >
          ${PRODUCT.price}
        </span>
        <span className="text-sm text-[color:rgba(11,18,32,0.6)]">
          one-time payment
        </span>
      </div>
      <p className="mt-2 inline-flex items-center gap-2 rounded-full bg-[color:rgba(214,162,30,0.12)] px-3 py-1 text-xs font-semibold text-[#B7791F]">
        Lifetime access · free updates included
      </p>
      <p className="mt-2 text-xs font-medium text-[color:rgba(11,18,32,0.62)]">
        {deliveryText}
      </p>

      <div className="mt-5 space-y-3">
        <BuyButton label={`Get access — $${PRODUCT.price}`} testId={STORE.productBuyButton} fullWidth size="lg" />
        <ul className="grid grid-cols-1 gap-2 rounded-xl bg-[var(--ibp-offwhite)] p-3 text-xs font-medium text-[color:rgba(11,18,32,0.72)] sm:grid-cols-2">
          {CTA_REASSURANCE.map(({ icon: Icon, text }) => (
            <li key={text} className="flex items-center gap-2">
              <Icon className="h-3.5 w-3.5 shrink-0 text-[#1F8A5B]" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
        <p className="text-center text-xs leading-5 text-[color:rgba(11,18,32,0.58)]">
          Access online from any modern browser — no download or app required.{" "}
          Use the same email as your free account so full access connects automatically.
        </p>
        <Link to="/study/login" className="text-center text-sm font-semibold text-[#0F3D8A] hover:underline">
          Not ready to buy? Start a free account
        </Link>
        <Link
          to="/preview"
          data-testid={STORE.productPreviewButton}
          className="inline-flex min-h-11 w-full items-center justify-center gap-2 rounded-xl border border-[color:rgba(10,27,51,0.18)] bg-white px-5 py-3 text-sm font-semibold text-[var(--ibp-ink)] transition-colors hover:bg-[var(--ibp-offwhite)]"
        >
          Preview What’s Inside
        </Link>
      </div>

      <div className="mt-5">
        <TrustBadges tone="light" />
      </div>

      <ul className="mt-5 space-y-2 border-t border-[color:rgba(10,27,51,0.10)] pt-5 text-xs leading-5 text-[color:rgba(11,18,32,0.7)]">
        {TRUST_POINTS.map((t) => (
          <li key={t} className="flex gap-2">
            <Check className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#1F8A5B]" />
            <span>{t}</span>
          </li>
        ))}
      </ul>

      <p className="mt-5 text-[11px] leading-5 text-[color:rgba(11,18,32,0.55)]">
        Not affiliated with PSI, IDFPR, the State of Illinois, or any real estate
        commission. No pass guarantee.
      </p>
    </div>
    </div>
  );
};

export default PurchaseCard;
